import { useEffect, useState } from 'react';

const KEY = 'compareList';
const EVENT = 'compare-changed';
export const COMPARE_MAX = 3;

const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const write = (items) => { localStorage.setItem(KEY, JSON.stringify(items)); window.dispatchEvent(new Event(EVENT)); };
const groupOf = (p) => `${p.category || ''}/${p.subcategory || ''}`;

// Product comparison list (max 3 items, same subcategory) stored in the browser
export const compareStore = {
  items: read,
  ids: () => read().map(i => String(i.id)),
  has: (id) => compareStore.ids().includes(String(id)),
  add: (product) => {
    const items = read();
    if (items.some(i => String(i.id) === String(product.id))) return { ok: true };
    if (items.length && items[0].group !== groupOf(product)) return { ok: false, reason: 'subcategory' };
    if (items.length >= COMPARE_MAX) return { ok: false, reason: 'max' };
    write([...items, { id: String(product.id), group: groupOf(product), category: product.category, subcategory: product.subcategory, name: product.name, image: product.image }]);
    return { ok: true };
  },
  remove: (id) => write(read().filter(i => String(i.id) !== String(id))),
  toggle: (product) => (compareStore.has(product.id) ? (compareStore.remove(product.id), { ok: true, removed: true }) : compareStore.add(product)),
  clear: () => write([]),
};

const useCompareState = (select) => {
  const [state, setState] = useState(() => select());
  useEffect(() => {
    const h = () => setState(select());
    window.addEventListener(EVENT, h);
    window.addEventListener('storage', h);
    return () => { window.removeEventListener(EVENT, h); window.removeEventListener('storage', h); };
  }, [select]);
  return state;
};

export const useCompareIds = () => useCompareState(compareStore.ids);
export const useCompareItems = () => useCompareState(compareStore.items);
